'use client'
import { usePathname } from 'next/navigation'
import { useEffect } from 'react'

import { track as coreTrack } from '../core/client'
import type { AnalyticsProps } from '../core/types'
import { Analytics as BaseAnalytics } from '../react/analytics'

export function Analytics(props: AnalyticsProps) {
  const pathname = usePathname()

  // Auto page view tracking on route change
  useEffect(() => {
    if (props.disabled) {
      return
    }
    coreTrack('page_viewed', {
      path: pathname,
      url: typeof window !== 'undefined' ? window.location.href : undefined,
      title: typeof document !== 'undefined' ? document.title : undefined,
    })
  }, [pathname, props.disabled])

  return <BaseAnalytics {...props} />
}
